<template>
    <!-- S: 생성하기 메인 -->
    <v-tab-item :value="TABS.CREATE.value" class="fill-height">
        <v-layout column justify-center class="h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <div class="mb-20 mb-lg-40">
                    <div class="mb-12 mb-lg-20 pt-4">
                        <v-badge floating dot>
                            <h4 class="tit--sm line-height-1">계약 정보</h4>
                        </v-badge>
                    </div>
                    <vertical-form-table
                        v-model="form"
                        v-bind="{
                            items,
                            class: 'flex-grow-1',
                        }"
                        @input="emit"
                    >
                        <template slot="계약서 선택">
                            <autocomplete-employment-form
                                v-model="form._form"
                                v-bind="{
                                    ...attrs_input,
                                    placeholder: '계약서를 선택해주세요',
                                }"
                                @input="emit"
                            />
                        </template>
                    </vertical-form-table>
                </div>
                <div>
                    <v-row align="center">
                        <v-col cols="12" md="">
                            <v-badge floating dot>
                                <h4 class="tit--sm line-height-1">선택된 계약 대상자</h4>
                            </v-badge>
                        </v-col>
                        <v-col cols="auto">
                            <span class="font-weight-bold"> 총 {{ selectedApplicationsLegth?.format?.() }}명 선택됨 </span>
                        </v-col>
                        <v-col cols="auto">
                            <v-row class="ma-n4">
                                <v-col cols="auto" class="pa-4">
                                    <v-btn outlined color="secondary" class="min-w-140px min-w-lg-160px" @click="next(TABS.SELECT.value)">채용공고에서 찾기</v-btn>
                                </v-col>
                                <v-col cols="auto" class="pa-4">
                                    <v-btn outlined color="primary" class="min-w-140px min-w-lg-160px" @click="next(TABS.SEARCH.value)">검색으로 찾기</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-card rounded="lg" flat color="grey-f7" class="mt-12 mt-md-20">
                        <div class="pa-20">
                            <slot />
                        </div>
                    </v-card>
                </div>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('exit')"
                >
                    <span class="grey-6--text">취소</span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="$emit('save')"><span>근로계약 체결</span></v-btn>
            </div>
        </v-layout>
    </v-tab-item>
    <!-- E: 생성하기 메인 -->
</template>

<script>
import { attrs_input, initEmploymentContract } from "@/assets/variables";
import { TABS } from "../lib";

import AutocompleteEmploymentForm from "@/components/dumb/autocomplete-employment-form.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "subject",
        term: "계약명",
        type: "text",
        required: true,
    },
    {
        key: "_form",
        term: "계약서 선택",
        required: true,
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        AutocompleteEmploymentForm,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, defatul: initEmploymentContract },
        loading: { type: Boolean, default: false },
        applications: { type: Array, default: () => [] },
    },
    data: () => ({
        form: initEmploymentContract(),

        TABS,
        items,
        attrs_input,
    }),
    computed: {
        selectedApplicationsLegth() {
            return this.applications.length;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentContract(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        next(tab) {
            this.$emit("next", tab);
        },
    },
};
</script>

<style></style>
